module.exports = __webpack_public_path__ + "img/logo-transparent.16ec9039.svg";